import React, { useEffect, useState } from "react";
import { Check, RotateCcw } from "lucide-react";
import { api } from "../../lib/api";
import { D, JAKARTA, inputStyle, Chip } from "./ui";
import { muatNamaKota } from "../kota/ui";

// Pengaturan → Nama Kota: ubah nama tampilan tiap kota tanpa menyentuh ID/URL/data.
// Kosongkan untuk kembali ke nama bawaan (kapitalisasi ID). Berlaku ke semua layar publik (pil atas, KWJ, Koran, Pesan Warga, Surat, Toa, Misi, Alun-alun).
export function KotaNamaPanel({ token }) {
  const [rows, setRows] = useState([]);
  const [draft, setDraft] = useState({});
  const [msg, setMsg] = useState("");
  const [sibuk, setSibuk] = useState("");

  const load = () => api.adminNamaKota(token).then(d => { setRows(d.kota || []); setDraft(Object.fromEntries((d.kota || []).map(k => [k.city_id, k.nama]))); }).catch(e => setMsg(e.message));
  useEffect(() => { load(); }, []); // eslint-disable-line

  async function simpan(cid, nama) {
    setSibuk(cid); setMsg("");
    try {
      const r = await api.adminSetNamaKota(token, cid, nama);
      setMsg(`Nama kota ${cid} kini tampil sebagai "${r.tampil}"`);
      await muatNamaKota();   // cache nama di browser admin ikut segar
      load();
    } catch (e) { setMsg(e.message); }
    setSibuk("");
  }

  return (
    <div data-testid="kota-nama-panel" style={{ fontFamily: JAKARTA }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <h3 style={{ margin: 0, fontSize: 20, fontWeight: 800, letterSpacing: -0.5, color: D.ink }}>Nama Kota</h3>
          <p style={{ margin: "4px 0 0", fontSize: 12.5, color: D.sub }}>Ubah nama yang tampil ke warga kapan saja. ID kota, alamat tautan, dan seluruh data warga tidak berubah. Kosongkan untuk memakai nama bawaan.</p>
        </div>
        {msg && <Chip testid="kota-nama-msg">{msg}</Chip>}
      </div>

      <div style={{ background: "#fff", borderRadius: 26, padding: "18px 22px", boxShadow: "0 8px 22px rgba(20,20,20,0.05)", overflowX: "auto" }}>
        <table data-testid="kota-nama-table" style={{ width: "100%", minWidth: 560, borderCollapse: "collapse", fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: "left", color: D.sub, fontSize: 11 }}>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>ID kota</th>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>Nama bawaan</th>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>Nama tampilan</th>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>Tampil sebagai</th>
              <th style={{ padding: "6px 8px", fontWeight: 700 }}>Aksi</th>
            </tr>
          </thead>
          <tbody>
            {rows.map(k => {
              const berubah = (draft[k.city_id] ?? "") !== (k.nama || "");
              return (
                <tr key={k.city_id} style={{ borderTop: `1px solid ${D.line}` }}>
                  <td style={{ padding: "10px 8px", color: D.sub, fontFamily: "ui-monospace, monospace" }}>{k.city_id}</td>
                  <td style={{ padding: "10px 8px", color: D.sub }}>{k.default}</td>
                  <td style={{ padding: "8px" }}>
                    <input data-testid={`nama-kota-${k.city_id}`} value={draft[k.city_id] ?? ""} maxLength={40} placeholder={k.default}
                      onChange={e => setDraft({ ...draft, [k.city_id]: e.target.value })}
                      onKeyDown={e => { if (e.key === "Enter" && berubah) simpan(k.city_id, draft[k.city_id] ?? ""); }}
                      style={{ ...inputStyle, width: 220 }} />
                  </td>
                  <td data-testid={`tampil-kota-${k.city_id}`} style={{ padding: "10px 8px", fontWeight: 800, color: D.ink }}>Kota {k.tampil}</td>
                  <td style={{ padding: "10px 8px", display: "flex", gap: 6 }}>
                    <button data-testid={`simpan-nama-${k.city_id}`} disabled={!berubah || sibuk === k.city_id} onClick={() => simpan(k.city_id, draft[k.city_id] ?? "")}
                      style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "6px 14px", background: berubah ? D.blue : D.blueSoft, color: berubah ? "#fff" : D.blue, border: 0, borderRadius: 99, fontSize: 12, fontWeight: 700, fontFamily: JAKARTA, cursor: berubah ? "pointer" : "default", opacity: sibuk === k.city_id ? 0.6 : 1 }}>
                      <Check size={12} /> Simpan
                    </button>
                    {k.nama && <button data-testid={`reset-nama-${k.city_id}`} title="Kembali ke nama bawaan" onClick={() => simpan(k.city_id, "")}
                      style={{ display: "inline-flex", alignItems: "center", gap: 5, padding: "6px 12px", background: "#fff", color: D.ink, border: `1.5px solid ${D.line}`, borderRadius: 99, fontSize: 12, fontWeight: 700, fontFamily: JAKARTA, cursor: "pointer" }}>
                      <RotateCcw size={12} /> Bawaan
                    </button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {rows.length === 0 && <p style={{ color: D.sub, fontSize: 13, margin: "12px 8px 4px" }}>Memuat daftar kota…</p>}
      </div>
    </div>
  );
}
